export default function getAppPath() {
  const mockPath = '/api/';
  const publicUrl = `${window.location.protocol}//${window.location.hostname}${process.env.PUBLIC_URL}`;
  return process.env.REACT_APP_MOCK_API === 'true' ? mockPath : publicUrl;
}
